var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("br"),
      _c("br"),
      _c("br"),
      _c("br"),
      _c("div", { staticClass: "text" }, [
        _vm._v("Bạn không có quyền để truy cập"),
      ]),
      _c("img", {
        staticClass: "picture",
        attrs: { src: require("@/assets/images/forbidden.gif") },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }